import { TAGS, api } from "@/store/api.ts"
import { ICardGameBalance } from "@/store/apis/balanceAPI/balance.types"

export const balanceApi = api.enhanceEndpoints({ addTagTypes: [TAGS.BALANCE] })

export const balanceEndpoints = balanceApi.injectEndpoints({
  endpoints: (builder) => ({
    getBalance: builder.query<ICardGameBalance, void>({
      query: () => ({
        url: "/balance",
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.BALANCE, id: "balance" }]
    })
  })
})

export const {
  useGetBalanceQuery,
  endpoints: { getBalance }
} = balanceEndpoints
